const NoData = ({ message = "No Data Found" }) => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center py-5"
      style={{ color: "#6c757d" }}
    >
      <p className="fw-semibold mb-0" style={{ fontSize: "1.1rem" }}>
        {message}
      </p>
    </div>
  );
};

export default NoData;
